// extracted by mini-css-extract-plugin
export default {"container":"W0-z","heading":"X0-z","links":"Y0-z","copy":"Z0-z","subCopy":"_0-z","linksLeft":"a1-z","linksCenter":"b1-z","linksRight":"c1-z","link":"d1-z","onlyLink":"e1-z"};